export default {"src":"/assets/turbo/e0bcbb6c/lascanaat/_next/static/media/coffee-cat.104e100c.svg","height":193,"width":191,"blurWidth":0,"blurHeight":0};